import { useEffect, useState } from "react";
import { api, euro } from "@/lib/api";
import { Users, ClipboardList, Boxes, TrendingUp } from "lucide-react";
import { STATUS_LABELS, statusColor } from "./Orders";

const ORDER = ["recue", "confirmee", "appelee", "preparee", "livree", "retiree", "annulee"];

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return <p className="text-brand-green">Chargement…</p>;

  const Stat = ({ icon: Icon, label, value, sub }) => (
    <div className="bg-white rounded-xl border border-brand-green/10 p-5">
      <div className="flex items-center gap-2 text-brand-green/60 text-sm mb-2"><Icon className="w-4 h-4 text-brand-gold" /> {label}</div>
      <div className="num text-3xl text-brand-green">{value}</div>
      {sub && <div className="text-xs text-brand-green/50 mt-1">{sub}</div>}
    </div>
  );

  return (
    <div>
      <h1 className="font-serif text-3xl font-bold text-brand-green mb-6">Tableau de bord</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-testid="dashboard-stats">
        <Stat icon={ClipboardList} label="À traiter" value={d.to_process} sub="Reçues, confirmées, appelées, préparées" />
        <Stat icon={Boxes} label="Sets réservés (saison)" value={d.sets_total} sub={`Valeur estimée ${euro(d.est_value)}`} />
        <Stat icon={Users} label="Visiteurs du jour" value={d.funnel.visitors} />
        <Stat icon={TrendingUp} label="Réservations du jour" value={d.funnel.reservations} sub={`${d.funnel.conversion}% de conversion`} />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border border-brand-green/10 p-5">
          <h2 className="font-serif text-xl font-bold text-brand-green mb-4">Réservations par statut</h2>
          {ORDER.map((s) => (
            <div key={s} className="flex items-center justify-between py-2 border-b border-brand-green/5 last:border-0">
              <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${statusColor(s)}`}>{STATUS_LABELS[s]}</span>
              <span className="font-bold text-brand-green">{d.by_status?.[s] || 0}</span>
            </div>
          ))}
        </div>
        <div className="bg-white rounded-xl border border-brand-green/10 p-5">
          <h2 className="font-serif text-xl font-bold text-brand-green mb-4">Sets réservés par gamme</h2>
          {d.season_by_gamme.length === 0 && <p className="text-brand-green/50 text-sm">Aucune réservation pour le moment.</p>}
          {d.season_by_gamme.map((s) => (
            <div key={s.name} className="flex items-center justify-between py-2 border-b border-brand-green/5 last:border-0">
              <span className="text-brand-green/70">{s.name}</span>
              <span className="font-bold text-brand-green">{s.count}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
